var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visibleFacets
    ? _c("nav", { staticClass: "g-facets", attrs: { id: "js-facets" } }, [
        _c(
          "div",
          {
            staticClass: "g-facets__overlay",
            attrs: { tabindex: "-1", "data-micromodal-close": "" },
          },
          [
            _c(
              "div",
              {
                staticClass: "g-facets__content",
                attrs: {
                  role: "dialog",
                  "aria-modal": "true",
                  "aria-labelledby": "g-facets-title",
                },
              },
              [
                _c("button", {
                  staticClass:
                    "g-button--no-styling u-icon-cross g-facets__close-button",
                  attrs: {
                    type: "button",
                    "aria-label": "Close Filters",
                    "data-micromodal-close": "",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "g-facets__form" }, [
                  _c(
                    "div",
                    {
                      staticClass: "g-facets__heading-section",
                      attrs: { id: "g-facets-title" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "g-facets__heading-container" },
                        [
                          _c(
                            "div",
                            { staticClass: "g-facets__heading-inner" },
                            [
                              _c("h2", { staticClass: "g-facets__heading" }, [
                                _c("span", {
                                  staticClass:
                                    "g-facets__heading-icon u-icon-filter",
                                  attrs: {
                                    "aria-hidden": "true",
                                    focusable: "false",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "g-facets__heading-text" },
                                  [
                                    _vm._v("Filter "),
                                    _vm.appliedFiltersCount
                                      ? _c("span", [
                                          _vm._v(
                                            " (" +
                                              _vm._s(_vm.appliedFiltersCount) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.appliedFiltersCount
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "g-facets__clear-all-link",
                                      on: {
                                        click: function ($event) {
                                          return _vm.clearFacets()
                                        },
                                      },
                                    },
                                    [_vm._v("Clear All")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.pagination && _vm.pagination.totalResults > 0
                        ? _c(
                            "div",
                            { staticClass: "g-facets__product-count" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "g-product-list__product-count",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.pagination.totalResults) +
                                      " " +
                                      _vm._s(
                                        _vm.pagination.totalResults > 1
                                          ? "Items"
                                          : "Item"
                                      )
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.appliedFiltersCount
                        ? _c(
                            "div",
                            { staticClass: "g-facets__applied-items" },
                            [
                              _c(
                                "ul",
                                { staticClass: "g-facets__list" },
                                _vm._l(_vm.appliedFilters, function (filter) {
                                  return _c(
                                    "li",
                                    {
                                      key: filter.filterValue,
                                      staticClass: "g-facets__applied-item",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "g-facets__applied-label",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleFilter(
                                                filter.field,
                                                typeof filter.value !== "object"
                                                  ? filter.value
                                                  : [
                                                      filter.value.rangeLow,
                                                      filter.value.rangeHigh,
                                                    ]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "g-facets__applied-label-icon u-icon-cross",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "g-facets__applied-label-text",
                                            },
                                            [_vm._v(_vm._s(filter.filterValue))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "g-facets__list-section" }, [
                    _c(
                      "ul",
                      { staticClass: "g-facets__list" },
                      _vm._l(_vm.visibleFacets, function (facet) {
                        return facet.field != "code" &&
                          (facet.type !== "hierarchy" ||
                            (facet.type === "hierarchy" &&
                              (_vm.hierarchyBreadcrumbValues ||
                                facet.values?.length)))
                          ? _c(
                              "li",
                              {
                                key: facet.field,
                                staticClass: "g-facet-set",
                                class: {
                                  "g-facet-set--collapsed": facet.collapse,
                                },
                              },
                              [
                                facet.nested
                                  ? _c(
                                      "h3",
                                      { staticClass: "g-facet-set__heading" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "g-facet-set__label g-facet-set__label--nested",
                                          },
                                          [
                                            facet._custom?.tippy
                                              ? _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "g-facet-set__heading-label g-facet-set__heading-tippy",
                                                    attrs: {
                                                      title:
                                                        facet._custom?.tippy,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(facet.label) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "g-facet-set__heading-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(facet.label) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "h3",
                                      {
                                        staticClass: "g-facet-set__heading",
                                        on: {
                                          click: function ($event) {
                                            facet.collapse = !facet.collapse
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "g-facet-set__label g-button--no-styling",
                                            attrs: {
                                              type: "button",
                                              id: `facet-control-${facet.field}`,
                                              "aria-controls": `facet-section-${facet.field}`,
                                              "aria-expanded": facet.collapse
                                                ? "false"
                                                : "true",
                                            },
                                          },
                                          [
                                            facet._custom?.tippy
                                              ? _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "g-facet-set__heading-label g-facet-set__heading-tippy",
                                                    attrs: {
                                                      title:
                                                        facet._custom?.tippy,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(facet.label) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "g-facet-set__heading-label",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(facet.label) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                      ]
                                    ),
                                _vm._v(" "),
                                facet.field === "bloom_color" &&
                                facet.values.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "g-facet-set__list",
                                        attrs: {
                                          id: `facet-section-${facet.field}`,
                                          role: "region",
                                          "aria-labelledby": `facet-control-${facet.field}`,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "g-facet-set__color" },
                                          _vm._l(
                                            facet.values,
                                            function (value, index) {
                                              return _c(
                                                "label",
                                                {
                                                  key: value.label,
                                                  class: [
                                                    "g-facet-set__list-item",
                                                    "g-form-checkbox",
                                                  ],
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: value.active,
                                                        expression:
                                                          "value.active",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "g-form-checkbox__input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        value.active
                                                      )
                                                        ? _vm._i(
                                                            value.active,
                                                            null
                                                          ) > -1
                                                        : value.active,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleFilter(
                                                          facet.field,
                                                          value.type === "value"
                                                            ? value.value
                                                            : [
                                                                value.low,
                                                                value.high,
                                                              ]
                                                        )
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a = value.active,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                value,
                                                                "active",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                value,
                                                                "active",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            value,
                                                            "active",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "g-form-checkbox__color",
                                                      attrs: {
                                                        title: value.label,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "g-form-checkbox__color--inner",
                                                          class: [
                                                            `g-form-checkbox__color--inner--${value.label
                                                              ?.toLowerCase?.()
                                                              .replace(
                                                                /[^\w ]+/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                / +/g,
                                                                "-"
                                                              )}`,
                                                          ],
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "u-hide-visually",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  value.label
                                                                ) +
                                                                  " (" +
                                                                  _vm._s(
                                                                    value.count
                                                                  ) +
                                                                  ")"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : facet.field === "ss_advantages" &&
                                    facet.values.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "g-facet-set__list",
                                        attrs: {
                                          id: `facet-section-${facet.field}`,
                                          role: "region",
                                          "aria-labelledby": `facet-control-${facet.field}`,
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "g-facet-set__advantages",
                                          },
                                          _vm._l(
                                            facet.values,
                                            function (value, index) {
                                              return _c(
                                                "label",
                                                {
                                                  key: value.label,
                                                  class: [
                                                    "g-facet-set__list-item",
                                                    "g-form-checkbox",
                                                  ],
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: value.active,
                                                        expression:
                                                          "value.active",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "g-form-checkbox__input",
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      checked: Array.isArray(
                                                        value.active
                                                      )
                                                        ? _vm._i(
                                                            value.active,
                                                            null
                                                          ) > -1
                                                        : value.active,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleFilter(
                                                          facet.field,
                                                          value.type === "value"
                                                            ? value.value
                                                            : [
                                                                value.low,
                                                                value.high,
                                                              ]
                                                        )
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$a = value.active,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = null,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              _vm.$set(
                                                                value,
                                                                "active",
                                                                $$a.concat([
                                                                  $$v,
                                                                ])
                                                              )
                                                          } else {
                                                            $$i > -1 &&
                                                              _vm.$set(
                                                                value,
                                                                "active",
                                                                $$a
                                                                  .slice(0, $$i)
                                                                  .concat(
                                                                    $$a.slice(
                                                                      $$i + 1
                                                                    )
                                                                  )
                                                              )
                                                          }
                                                        } else {
                                                          _vm.$set(
                                                            value,
                                                            "active",
                                                            $$c
                                                          )
                                                        }
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "g-form-checkbox__advantage",
                                                    },
                                                    [
                                                      value._custom?.image
                                                        ? _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "tippy",
                                                                  rawName:
                                                                    "v-tippy",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "facet-advantage",
                                                              class: [
                                                                value._custom
                                                                  ?.class,
                                                              ],
                                                              attrs: {
                                                                title:
                                                                  value._custom
                                                                    ?.title,
                                                              },
                                                            },
                                                            [
                                                              _c("img", {
                                                                staticClass:
                                                                  "facet-advantage-image",
                                                                attrs: {
                                                                  src: value
                                                                    ._custom
                                                                    .image,
                                                                  alt: value
                                                                    ._custom
                                                                    ?.title,
                                                                  loading:
                                                                    "lazy",
                                                                },
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "tippy",
                                                                  rawName:
                                                                    "v-tippy",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "facet-advantage",
                                                              class: [
                                                                value._custom
                                                                  ?.class,
                                                              ],
                                                              attrs: {
                                                                title:
                                                                  value._custom
                                                                    ?.title,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    value
                                                                      ._custom
                                                                      ?.label ||
                                                                      value.label
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : facet.type === "hierarchy"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "g-facet-set__list",
                                        attrs: {
                                          id: `facet-section-${facet.field}`,
                                          role: "region",
                                          "aria-labelledby": `facet-control-${facet.field}`,
                                        },
                                      },
                                      [
                                        _vm._l(
                                          _vm.hierarchyBreadcrumbValues,
                                          function (breadcrumb, index) {
                                            return _vm.hierarchyBreadcrumbValues
                                              ? _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    class: `g-facet-set__list-item g-facet-set__list-item--no-link g-facet-set__list-item--level-${
                                                      index === 0 ? "1" : "2"
                                                    }`,
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "g-facet-set__list-item-name g-facet-set__list-item-name--applied",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(breadcrumb) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.hierarchyBreadcrumbValuesLast
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          facet.values,
                                          function (value, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: value.label,
                                                class: [
                                                  "g-facet-set__list-item",
                                                  `g-facet-set__list-item--level-${
                                                    _vm.hierarchyBreadcrumbValues
                                                      ? "2"
                                                      : "1"
                                                  }`,
                                                  {
                                                    "u-hidden":
                                                      index + 1 >
                                                      _vm.facetShowCount,
                                                  },
                                                ],
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "g-facet-set__list-item-link g-button--no-styling",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleFilter(
                                                          facet.field,
                                                          value.type === "value"
                                                            ? value.value
                                                            : [
                                                                value.low,
                                                                value.high,
                                                              ]
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: [
                                                          "g-facet-set__list-item-name",
                                                          {
                                                            "g-facet-set__list-item-name--applied":
                                                              value.active,
                                                          },
                                                        ],
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(value.label)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "g-facet-set__list-item-count",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              value.count
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        facet.values.length > _vm.facetShowCount
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "g-facet-set__list-show-more",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "g-facet-set__list-show-more-link g-button--no-styling",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: _vm.viewMoreClick,
                                                    },
                                                  },
                                                  [_vm._v("View More")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : facet.nested
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "g-facet-set__list g-facet-set__list--nested",
                                        attrs: {
                                          id: `facet-section-${facet.field}`,
                                        },
                                      },
                                      _vm._l(facet.items, function (facetItem) {
                                        return _c(
                                          "div",
                                          {
                                            key: facetItem.field,
                                            class: [
                                              "g-facet-set__list-nested-item",
                                              {
                                                "g-facet-set--collapsed":
                                                  facetItem.collapse,
                                              },
                                            ],
                                          },
                                          [
                                            _c(
                                              "h4",
                                              {
                                                staticClass:
                                                  "g-facet-set__heading",
                                                on: {
                                                  click: function ($event) {
                                                    facetItem.collapse =
                                                      !facetItem.collapse
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "g-facet-set__label g-button--no-styling",
                                                    attrs: {
                                                      type: "button",
                                                      id: `facet-control-${facetItem.field}`,
                                                      "aria-controls": `facet-section-${facetItem.field}`,
                                                      "aria-expanded":
                                                        facetItem.collapse
                                                          ? "false"
                                                          : "true",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          facetItem.label
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            (facetItem.type === "list" ||
                                              facetItem.type == null) &&
                                            facetItem.values.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "g-facet-set__list",
                                                    attrs: {
                                                      id: `facet-section-${facetItem.field}`,
                                                      role: "region",
                                                      "aria-labelledby": `facet-control-${facetItem.field}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._l(
                                                      facetItem.values,
                                                      function (value, index) {
                                                        return _c(
                                                          "label",
                                                          {
                                                            key: value.label,
                                                            class: [
                                                              "g-facet-set__list-item",
                                                              "g-form-checkbox",
                                                              {
                                                                "u-hidden":
                                                                  index + 1 >
                                                                  _vm.facetShowCount,
                                                              },
                                                            ],
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    value.active,
                                                                  expression:
                                                                    "value.active",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "g-form-checkbox__input",
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                checked:
                                                                  Array.isArray(
                                                                    value.active
                                                                  )
                                                                    ? _vm._i(
                                                                        value.active,
                                                                        null
                                                                      ) > -1
                                                                    : value.active,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleFilter(
                                                                      facetItem.field,
                                                                      value.type ===
                                                                        "value"
                                                                        ? value.value
                                                                        : [
                                                                            value.low,
                                                                            value.high,
                                                                          ]
                                                                    )
                                                                  },
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        value.active,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          null,
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            value,
                                                                            "active",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            value,
                                                                            "active",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        value,
                                                                        "active",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "g-facet-set__list-item-link g-form-checkbox__caption",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "tippy",
                                                                          rawName:
                                                                            "v-tippy",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "g-facet-set__list-item-name",
                                                                    attrs: {
                                                                      title:
                                                                        value
                                                                          ._custom
                                                                          ?.title,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        value.label
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "g-facet-set__list-item-count",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "(" +
                                                                        _vm._s(
                                                                          value.count
                                                                        ) +
                                                                        ")"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    facetItem.values.length >
                                                    _vm.facetShowCount
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "g-facet-set__list-show-more",
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "g-facet-set__list-show-more-link g-button--no-styling",
                                                                attrs: {
                                                                  type: "button",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.viewMoreClick,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "View More"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : (facet.type === "list" ||
                                      facet.type == null) &&
                                    facet.values.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "g-facet-set__list",
                                        attrs: {
                                          id: `facet-section-${facet.field}`,
                                          role: "region",
                                          "aria-labelledby": `facet-control-${facet.field}`,
                                        },
                                      },
                                      [
                                        _vm._l(
                                          facet.values,
                                          function (value, index) {
                                            return _c(
                                              "label",
                                              {
                                                key: value.label,
                                                class: [
                                                  "g-facet-set__list-item",
                                                  "g-form-checkbox",
                                                  {
                                                    "u-hidden":
                                                      index + 1 >
                                                      _vm.facetShowCount,
                                                  },
                                                ],
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: value.active,
                                                      expression:
                                                        "value.active",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "g-form-checkbox__input",
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      value.active
                                                    )
                                                      ? _vm._i(
                                                          value.active,
                                                          null
                                                        ) > -1
                                                      : value.active,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleFilter(
                                                        facet.field,
                                                        value.type === "value"
                                                          ? value.value
                                                          : [
                                                              value.low,
                                                              value.high,
                                                            ]
                                                      )
                                                    },
                                                    change: function ($event) {
                                                      var $$a = value.active,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              value,
                                                              "active",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              value,
                                                              "active",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          value,
                                                          "active",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "g-facet-set__list-item-link g-form-checkbox__caption",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "tippy",
                                                            rawName: "v-tippy",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "g-facet-set__list-item-name",
                                                        attrs: {
                                                          title:
                                                            value._custom
                                                              ?.title,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(value.label)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "g-facet-set__list-item-count",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "(" +
                                                            _vm._s(
                                                              value.count
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        facet.values.length > _vm.facetShowCount
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "g-facet-set__list-show-more",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "g-facet-set__list-show-more-link g-button--no-styling",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: _vm.viewMoreClick,
                                                    },
                                                  },
                                                  [_vm._v("View More")]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }